module.exports = __webpack_public_path__ + "img/classic.13638105.png";